<div
    class="login-page"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="sidebar {{partnerReseller}}"
        [ngClass]="{'sidebar-reseller': isResellerDomain}"
    >
        <div
            [formGroup]="loginForm"
            class="login-form"
        >
            <img
                *ngIf="!!logoUrl"
                [src]="logoUrl"
                [alt]="logoAltText | localize"
                class="login-logo"
            />

            <ng-container
                *ngTemplateOutlet="loginMessageState === loginMessageStateEnum.none ? null : loginState"
            ></ng-container>

            <agpr-message
                *ngIf="username.errors?.['required'] && username.touched"
                class="login-error"
                [severity]="messageSeverityEnum.error"
            >
                {{ 'Core.sso.login.error.requiredFields' | localize }}
            </agpr-message>
            <agpr-text-input
                formControlName="username"
                [id]="id + '_username'"
                class="login-username"
                label="Core.login.email"
                name="username"
                type="text"
                placeholder="Core.login.placeholderUser"
                (keyup)="onEnter($event)"
                [disabled]="loginMessageState === loginMessageStateEnum.loginInProgress"
            ></agpr-text-input>
            <agpr-button
                [id]="id + '_button'"
                class="login-button"
                label="Core.sso.login"
                (click)="ssoSignIn()"
                [style]="buttonTypes.primary"
                [disabled]="loginMessageState === loginMessageStateEnum.loginInProgress"
            ></agpr-button>
            <div class="divide">
                <span> {{ 'Core.sso.login.or' | localize }} </span>
            </div>
            <a
                class="agility-link"
                routerLink="/login"
            >
                {{ 'Core.sso.login.signInWithPassword' | localize }}
            </a>
        </div>
        <div class="footer">
            <a
                *ngIf="partnerReseller !== partnerResellerEnum.burrelles"
                class="link"
                target="_blank"
                href="https://www.agilitypr.com/contact/"
            >
                {{ 'Core.login.productHelp' | localize }}
            </a>
            <div [innerHTML]="'Agility.copyright' | localize"></div>
        </div>
    </div>
    <div class="marketing-iframe">
        <!-- TODO : Use different URL based on environment ? -->
        <iframe
            [title]="'Login.marketingIframe.title' | localize"
            src="https://www.agilitypr.com/login-background/"
            sandbox="allow-same-origin allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
            scrolling="no"
            class="u-full-width u-full-height u-iframe-unstyled u-no-borders">
        </iframe>
    </div>
</div>

<ng-template
    #loginState
    [ngSwitch]="loginMessageState"
>
    <ng-container *ngSwitchCase="loginMessageStateEnum.loginInProgress">
        <agpr-message [severity]="messageSeverityEnum.info">
            {{ 'Core.sso.login.inProgress' | localize }}
        </agpr-message>
        <div [agprLoading]="true"></div>
    </ng-container>

    <agpr-message
        *ngSwitchCase="loginMessageStateEnum.microsoftConsentFailure"
        [severity]="messageSeverityEnum.warning"
    >
        {{ 'Core.sso.login.consentError' | localize }}
    </agpr-message>

    <agpr-message
        *ngSwitchCase="loginMessageStateEnum.redirectFromPasswordLogin"
        [severity]="messageSeverityEnum.warning"
    >
        {{ 'Core.sso.login.ssoRedirect' | localize }}
    </agpr-message>

    <ng-container *ngSwitchCase="loginMessageStateEnum.authError">
        <agpr-message [severity]="messageSeverityEnum.error">
            {{ 'Core.sso.login.authError' | localize }}
        </agpr-message>
        <agpr-message [severity]="messageSeverityEnum.error">
            {{ 'Core.sso.login.lockedOutWarning' | localize }}
        </agpr-message>
    </ng-container>

    <agpr-message
        *ngSwitchCase="loginMessageStateEnum.authErrorLockOut"
        [severity]="messageSeverityEnum.error"
    >
        {{ 'Core.login.lockedOut' | localize }}
    </agpr-message>
</ng-template>
